<div class="attributes-container">
  <p class="attributes-breadcrumbs">
    <a [routerLink]="'/' | addLocale">YES</a>
    <span class="separator"> / </span>
    @for (breadcrumb of breadcrumbs; track breadcrumb.href; let last = $last) {
      @if (breadcrumb.href && !last) {
        <a [routerLink]="'/t/' + breadcrumb.href | addLocale">
          {{ breadcrumb.name }}
        </a>
      }
      @if (!last) {
        <span class="separator"> / </span>
      }
      @if (!breadcrumb.href || last) {
        <span>{{ breadcrumb.name }}</span>
      }
    }
  </p>
  <div class="hide-on-desktop">
    <h1>{{ metaData.category.name }}</h1>
    <span class="count">({{ metaData.count }})</span>
  </div>
  <div class="attributes-description hide-on-mobile" [innerHtml]="description"></div>
</div>

<div class="img-container hide-on-mobile">
  @if (metaData.category.image; as image) {
    <img [src]="image.url" [alt]="image.alt" />
  }
</div>
